import { Delete } from "lucide-react"
import { Button, Col, Form, Row, InputGroup } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function TemplateForm({state, handleInputChange, submit, isAddingOrEditing, isRegistering}) {
	const { t } = useTranslation()

	const handleStepChange = (index, field, value) => {
		const newSteps = [...(state.steps || [])]
		newSteps[index] = {
			...newSteps[index],
			[field]: field === 'day' ? parseInt(value) : value
		}
		handleInputChange({ target: { name: 'steps', value: newSteps } })
	}

	const addStep = () => {
		const newSteps = [...(state.steps || []), { day: 0, step: '', assignedTo: 'technical' }]
		handleInputChange({ target: { name: 'steps', value: newSteps } })
	}

	const removeStep = (index) => {
		const newSteps = [...(state.steps || [])]
		newSteps.splice(index, 1)
		handleInputChange({ target: { name: 'steps', value: newSteps } })
	}

	return (
		<Form onSubmit={submit} className="px-4 formulario">
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.template.name')}</Form.Label>
						<Form.Control
							type="text"
							name="name"
							value={state.name || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
				<Col xs={12}>
					<Row className="mb-3">
						<Form.Label>{t('admin.template.steps')}</Form.Label>
						{state?.steps?.length > 0 ?
							<Row className="mb-2 align-items-end">
								<Col xs={2}>
									<Form.Label>{t('admin.template.day')}</Form.Label>
								</Col>
								<Col xs={7}>
									<Form.Label>{t('admin.template.step')}</Form.Label>
								</Col>
								<Col xs={2}>
									<Form.Label>{t('admin.template.assignedTo')}</Form.Label>
								</Col>
								<Col xs={1}></Col>
							</Row>
						:
							<></>
						}
						{(state.steps || []).map((stepItem, index) => (
							<Row key={index} className="mb-2 align-items-end">
								<Col xs={2}>
									<Form.Control
										type="number"
										value={stepItem.day}
										onChange={(e) => handleStepChange(index, 'day', e.target.value)}
										required
									/>
								</Col>
								<Col xs={7}>
									<Form.Control
										type="text"
										value={stepItem.step}
										onChange={(e) => handleStepChange(index, 'step', e.target.value)}
										required
									/>
								</Col>
								<Col xs={2}>
									<Form.Select
										value={stepItem.assignedTo || 'technical'}
										onChange={(e) => handleStepChange(index, 'assignedTo', e.target.value)}
									>
										<option value="technical">{t('admin.template.technical')}</option>
										<option value="breeder">{t('admin.template.breeder')}</option>
									</Form.Select>
								</Col>
								<Col xs={1} style={{height: '40px'}}>
									<Delete size={32} className="me-2 text-danger align-self-center" style={{cursor: 'pointer'}} onClick={() => removeStep(index)}/>
								</Col>
							</Row>
						))}
						<Button variant="secondary" onClick={addStep}>
							{t('admin.template.addStep')}
						</Button>
					</Row>
				</Col>
			</Row>
			<Row>
				<Col xs={12} lg={6} className="my-2 ms-auto">
					<Button variant='primary' type="submit" className="w-100 my-2">
					{isRegistering ?
						<>
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</>
					:
						isAddingOrEditing === 'editing' ?
							<>{t('admin.template.edit')}</>
						:
							<>{t('admin.template.register')}</>
					}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
